module.exports = __webpack_public_path__ + "static/media/add.156bb2c8.svg";